<template>
  <div class="main-graph-window">
    <div v-click-outside="closeMatrix" v-if="matrixView">
      <matrix-view-component
        :matrix-view="matrixView"
        :main-sector="mainSector"
        :sub-sector="selectedTab"
      />
    </div>
    <div class="menu-wrapper" @mouseenter="matrixView = false">
      <ul class="sub-menu-dropup">
        <li
          class="dropdown-item btn btn-block btn-light-gray"
          v-for="tab in paginate(graphTabs)[tabPaginate]"
          :key="tab"
          @click="TabClick(tab)"
          @mouseenter="hoveringTab = tab.alias"
          @mouseleave="hoveringTab = false"
          :class="{
            active: selectedTab === tab.alias.toUpperCase(),
            'cal-match':
              selectedCalendarType.alias === mainCalendarSection &&
              selectedTab === tab.alias
          }"
        >
          <i
            class="fas fa-times cancel-filter"
            v-if="checkFilterTab(tab.alias)"
            @click.stop="resetTabFilter(tab.alias)"
          ></i>
          <span
            class="dropdown-item-left"
            :class="{
              longTitleFontSize: tab.name.length > 6
            }"
            >{{ tab.name }}</span
          >
          <span
            class="dropdown-item-right"
            v-if="
              tab.hasOwnProperty('subMenu') || tab.hasOwnProperty('presetTabs')
            "
            ><i class="fas fa-caret-right"></i
          ></span>

          <!--          default sub menus-->
          <ul
            v-click-outside="closeSubTab"
            class="sub-menu-main"
            v-if="
              tab.hasOwnProperty('subMenu') &&
                ((hoveringTab === tab.alias || selectedTab === tab.alias) &&
                  openSubTab)
            "
          >
            <li
              class="dropdown-item btn btn-block btn-light-gray"
              v-for="subTab in tab.subMenu"
              :key="subTab.id"
              @click.stop="clickSubTab(tab, subTab)"
              :class="{
                active: selectedSubTab === subTab.alias
              }"
            >
              <span class="dropdown-item-left sub">{{ subTab.name }}</span>
            </li>
          </ul>

          <!--          presets sub menus-->
          <ul
            v-click-outside="closeSubTab"
            class="sub-menu-main"
            v-if="tab.hasOwnProperty('presetTabs') && hoveringTab === tab.alias"
          >
            <li
              class="dropdown-item btn btn-block btn-light-gray"
              v-for="subTab in statsTabs"
              :key="subTab.id"
              @click.stop="setPresetFromTab(subTab, tab, true)"
              :class="{
                active: selectedCalendarType.preset === subTab.alias
              }"
            >
              <span class="dropdown-item-left sub">{{ subTab.name }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="arrow-down">
        <!--        <div class="presets-container dropup">-->
        <!--&lt;!&ndash;          <button&ndash;&gt;-->
        <!--&lt;!&ndash;            class="btn btn-info pre-btn dropdown-toggle"&ndash;&gt;-->
        <!--&lt;!&ndash;            data-toggle="dropdown"&ndash;&gt;-->
        <!--&lt;!&ndash;          >&ndash;&gt;-->
        <!--&lt;!&ndash;            PRESETS&ndash;&gt;-->
        <!--&lt;!&ndash;          </button>&ndash;&gt;-->
        <!--          <div class="dropdown-menu sub-menu-presets-tab">-->
        <!--            <button-->
        <!--              class="btn btn-block preset-tab"-->
        <!--              v-for="subTab in presetsTabs"-->
        <!--              :key="subTab.id"-->
        <!--              @click.stop="setPresetFromTab(subTab, tab)"-->
        <!--              :class="{-->
        <!--                active: selectedCalendarType.preset === subTab.alias-->
        <!--              }"-->
        <!--            >-->
        <!--              {{ subTab.name }}-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <i-->
        <!--          v-if="graphTabs.length > tabsLength"-->
        <!--          :class="{-->
        <!--            disabled_scroll: paginate(graphTabs)[tabPaginate + 1] === undefined-->
        <!--          }"-->
        <!--          class="fas fa-angle-down"-->
        <!--          @click="tabPaginate++"-->
        <!--        ></i>-->
        <!--        <i-->
        <!--          v-if="graphTabs.length > tabsLength"-->
        <!--          :class="{-->
        <!--            disabled_scroll: paginate(graphTabs)[tabPaginate - 1] === undefined-->
        <!--          }"-->
        <!--          class="fas fa-angle-up"-->
        <!--          @click="tabPaginate&#45;&#45;"-->
        <!--        ></i>-->
      </div>
    </div>
    <div class="chart-section">
      <div class="deposit-chart">
        <div class="for-presets">
          <div class="presets-container dropup">
            <!--          <button-->
            <!--            class="btn btn-info pre-btn dropdown-toggle"-->
            <!--            data-toggle="dropdown"-->
            <!--          >-->
            <!--            PRESETS-->
            <!--          </button>-->
            <div class="dropdown-menu sub-menu-presets-tab">
              <button
                class="btn btn-block preset-tab"
                v-for="subTab in presetsTabs"
                :key="subTab.id"
                @click.stop="setPresetFromTab(subTab, tab)"
                :class="{
                  active: validPreset(mainCalendarSection) === subTab.alias
                }"
              >
                {{ subTab.name }}
              </button>
              <button
                class="btn btn-block preset-tab stats-btn"
                @click="setMatrixView(selectedTab)"
                v-if="checkForMatrix(selectedTab)"
              >
                STATS
              </button>
            </div>
            <div class="top-bar" v-if="counters.users > 0">
              <div class="inner-bar">total ld: {{ counters.ld }}</div>
              <div class="inner-bar">total users: {{ counters.users }}</div>
              <div class="inner-bar" v-if="ldDates">
                dates:
                {{ ldDates[0] }} -
                {{ ldDates[1] }}
                <span class="for-diff-in-days">{{ ldDates[2] }}</span>
              </div>
            </div>
          </div>
        </div>
        <canvas class="ld-chart" id="main-chart-ld"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CahartAnnot from "chartjs-plugin-annotation";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import vClickOutside from "v-click-outside";
import calendarCheck from "@/mixins/tags/calendarCheck";
import presetsValidator from "@/mixins/presets/presetsValidator";

const StatusBar = {
  type: "bar",
  options: {
    animation: {
      duration: 0
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },
    // legend: {
    //     position: "top",
    //     align: "end",
    //     labels: {
    //         boxWidth: 20,
    //         fontSize: 10,
    //         display: false
    //     },
    //     onHover: function(e) {
    //         e.target.style.cursor = 'pointer';
    //     }
    // },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "LdCharts.component",
  components: {},
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "multiSelectChartData",
      "selectedCalendarType",
      "clickFromChart",
      "generalQueryObject"
    ]),
    ...mapGetters("clients", ["getMultiSelectChartData"])
  },
  mixins: [UsersPermissionCheck,presetsValidator],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Array,
      required: true
    },
    presetsTabs: {
      type: Array,
      required: true
    },
    statsTabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      StatusBar: StatusBar,
      hoveringTab: false,
      openSubTab: false,
      graphTabs: [],
      mainCalendarSection: "LEAD_TAG",
      statusChartTab: null,
      selectedTab: "",
      tabPaginate: 0,
      tabsLength: 8,
      ext_tabs: [],
      matrixView: false,
      globalDateRange: "TODAY",
      counters: {
        ld: 0,
        users: 0
      },
      ldDates: null
    };
  },
  watch: {
    multiSelectChartData: {
      handler() {
        this.initialChartData(this.getMultiSelectChartData);
      },
      deep: true
    }
  },
  created() {
    this.graphTabs = this.tabs;
    this.selectedTab = this.graphTabs[0].alias.toUpperCase();
  },
  mounted() {},
  methods: {
    diffTimeInDaysForNaChartTitle(d1, d2) {
      let date1 = new Date(d1);
      let date2 = new Date(d2);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + 1 + "Days";
    },
    async initialChartData(data) {
      if (this.mainSector === data.selectedSector) {
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).removeClass("loading");
        if (data.fromChart) {
          return;
        }
        let tab = this.ext_tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tab.length > 0) {
          await this.fetchExternalGraphs(tab[0]);
          return;
        }
        // this.$store.commit("clients/setSelectedCalendarType", {
        //   alias: this.mainCalendarSection,
        //   preset: null
        // });
        this.mainSector = data.selectedSector;
        this.allData = data;
        this.chartData = data.data[this.mainSector].data;
        this.selectedTab = data.data[this.mainSector].selectedTab.toUpperCase();
        let lineChartStatus = `main-chart-ld`;
        if (this.statusChartTab) {
          this.statusChartTab.destroy();
        }
        if (!this.chartData.hasOwnProperty(this.mainSector)) {
          this.createChart(
            lineChartStatus,
            this.StatusBar,
            this.chartData,
            this.selectedTab
          );
        }
      }
    },
    async TabClick(tab) {
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        // if (this.selectedTab !== tab.alias) {
        //   this.$store.commit("clients/setSelectedCalendarType", {
        //     alias: this.mainCalendarSection,
        //     preset: null
        //   });
        // }
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        await this.fetchExternalGraphs(tab);
      }
    },
    checkForMatrix(mainTab) {
      let allTabs = [...this.tabs, ...this.ext_tabs];
      return allTabs.find(tab => {
        return tab.alias === mainTab && tab.hasOwnProperty("presetTabs");
      });
    },
    clickSubTab(subTab) {
      this.selectedSubTab = subTab.alias;

      //functions of sub tabs
    },
    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },

    createChart(chartId, chartOpt, stats) {
      let opt = chartOpt.options;
      let NewData = stats;
      let labels = [];
      let onlineCounts = [];
      let ids = [];
      if (NewData.length > 0) {
        NewData = NewData.sort((a, b) => {
          if (a.count[0] > b.count[0]) {
            return -1;
          }
          if (a.count[0] < b.count[0]) {
            return 1;
          }
          return 0;
        });

        NewData.forEach(num1 => {
          if (num1.count[0] === 0) {
            return;
          }
          labels.push(num1.title.substring(0, 17));
          onlineCounts.push(num1.count[0]);
          ids.push(num1.id);
        });
      }

      if (this.generalQueryObject.hasOwnProperty("last_modified_lead_from")) {
        this.ldDates = [
          this.generalQueryObject.last_modified_lead_from
            .split("-")
            .reverse()
            .join("-"),
          this.generalQueryObject.last_modified_lead_to
            .split("-")
            .reverse()
            .join("-"),
          this.diffTimeInDaysForNaChartTitle(
            this.generalQueryObject.last_modified_lead_from,
            this.generalQueryObject.last_modified_lead_to
          )
        ];
      } else {
        this.ldDates = null;
      }
      this.counters.ld = onlineCounts.reduce((a, b) => a + b, 0);
      this.counters.users = onlineCounts.length;

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: onlineCounts, //onlineTrans,
            fill: true,
            borderColor: "rgb(66, 117, 236)",
            backgroundColor: "rgb(66, 117, 236,0.5)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.statusChartTab) {
        this.statusChartTab.destroy();
      }
      if (opt.annotation) {
        opt.annotation = null;
      }
      if (onlineCounts.length > 0) {
        opt.annotation = this.returnAverageLine(
          onlineCounts.reduce((a, b) => a + b) / onlineCounts.length,
          true,
          "rgb(66, 117, 236,0.5)",
          350
        );
      }

      const ctx = document.getElementById(chartId);
      this.statusChartTab = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnChart(this.statusChartTab, evt, ids);
      };
    },
    returnAverageLine: (avg, enabled, lineColor, pose, YAdjust = -10) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            // Background color of label, default below
            backgroundColor: "rgba(0,0,0,0)",

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            // fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#000",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: YAdjust,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),
    defaultPresets(range = this.globalDateRange) {
      if (range === "TODAY") {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          start: today,
          end: today
        };
      }
      if (range === "YESTERDAY") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .toDate();
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const n = new Date();
        const startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }

      if (range === "LAST_30_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_90_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_180_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "TOMORROW") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
        );
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "NEXT_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
        );
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    resetMainFilters() {
      this.mainFilters = {
        deposit_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    },

    setPresetFromTab(subTab, mainTab, setTab = null) {
      if (subTab.presetTab) {
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: this.mainCalendarSection,
          preset: subTab.alias
        });
      } else {
        this.setMatrixView(mainTab);
      }
      if (setTab) {
        if (this.selectedTab !== mainTab.alias) {
          this.TabClick(mainTab);
        }
      }
    },
    setMatrixView(tab) {
      this.matrixView = true;
    },
    closeMatrix() {
      this.matrixView = false;
    },

    resetTabFilter(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        mainObj.data[this.mainSector][tab] = false;
      } else {
        mainObj.data[this.mainSector] = {
          [tab]: false
        };
      }
      mainObj.lastSector = this.mainSector;
      mainObj.subSector = this.selectedTab;
      this.$store.commit("clients/setClickFromChart", mainObj);
    },
    checkFilterTab(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        if (mainObj.data[this.mainSector].hasOwnProperty(tab)) {
          if (mainObj.data[this.mainSector][tab]) {
            return true;
          }
        }
      }
      return false;
    },
    clickOnChart(chart, evt, ids) {
      let activePoints = chart.getElementAtEvent(evt);
      if (activePoints[0]) {
        let idx = activePoints[0]["_index"];
        let selectedId = ids[idx];
        let mainObj = Object.assign({}, this.clickFromChart);
        if (mainObj.data.hasOwnProperty(this.mainSector)) {
          mainObj.data[this.mainSector][this.selectedTab] = [
            { id: selectedId }
          ];
        } else {
          mainObj.data[this.mainSector] = {
            [this.selectedTab]: [{ id: selectedId }]
          };
        }
        mainObj.lastSector = this.mainSector;
        mainObj.subSector = this.selectedTab;
        this.$store.commit("clients/setClickFromChart", mainObj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  //padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
  /* overflow-x: visible;*/
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 12px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
}

.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*  padding: 1px 0px;
  margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: #efefef;
  border: 1px solid #e5e4e4;
  position: relative;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 95px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  flex: 1;
}
.chart-section {
  flex: 2;
  width: 92%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}
li.active {
  background-color: #4275ec;
  color: #fff;
}
.sized_chart {
  max-width: 74%;
  position: relative;
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 55px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}
.sub-menu-main li {
  background-color: #efefef;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 5px;
}
.sub-menu-main li:hover {
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #c12fff;
  color: #fff;
}

.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
li.loading {
  background: linear-gradient(-45deg, #4275ec, #1d3d85, #4275ec, #1d3d85);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }
  //50% {
  //  background-position: 100% 50%;
  //}
  100% {
    background-position: 100% 50%;
  }
}
.arrow-down {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4275ec;
  font-size: 29px;
  cursor: pointer;
}
.disabled_scroll {
  display: none;
}
.cancel-filter {
  margin-top: 2px;
  margin-left: 5px;
}

.presets-container {
  height: 20px;
  margin: 0px;
  padding: 0px;
  display: flex;
  position: relative;
  top: -8px;
  left: -75px;
}
.pre-btn:focus {
  outline: none;
}
.pre-btn {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-menu-presets-tab {
  display: flex;
  flex-direction: row;
  padding-left: 2px;
  margin-left: 63px;
  border: none;
  top: -7px;
  background: none;
}
.preset-tab {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  max-width: 52px;
  margin-top: 0;
  margin-left: 3px;
}
.preset-tab:active {
  background: #a8a5a5;
}
.preset-tab.active {
  background-color: #4275ec;
  color: #fff;
}
.preset-tab:focus {
  outline: none;
}
.preset-tab:hover {
  background: #d7d7d7;
}
.stats-btn {
  color: #4275ec;
  font-weight: bold;
}

.top-bar {
  display: flex;
  justify-content: space-evenly;
  background-color: #efefef;
  width: 100%;
  height: 15px;
  font-size: 10px;
  position: absolute;
  top: 23px;
  left: 73px;
}
.inner-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
span.for-diff-in-days {
  padding-left: 8px;
}
.ld-chart {
  height: 160px !important;
  padding-top: 10px !important;
}
</style>
